import * as React from 'react';

export function withIcon<P extends object>(icon: React.ReactNode) {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>) => {
    return (props: P) => <WrappedComponent {...props} icon={icon} />;
  };
}

export type Icons = { [name: string]: React.ReactNode };

/**
 * Provides several named icons as an `icons` prop, e.g. `withIcons({ newEntry: <MdLogin />, edit: <MdEdit /> })`
 * and in the component `props.icons.newEntry`.
 */
export function withIcons<P extends object>(icons: Icons) {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>) => {
    return (props: P) => <WrappedComponent {...props} icons={icons} />;
  };
}
